import React, {
  useCallback, useState,
} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { setPage } from '../data/page/actions';
import VRAPendingList from '../views/VRAPending/VRAPendingList';
import VRAPendingDetails from '../views/VRAPending/VRAPendingDetails';
import pendingReturnInvoicesQuery from '../graphql/pendingReturnInvoicesQuery';
import VRAPendingSearch from '../views/VRAPending/VRAPendingSearch';
import withPagination from './WithPagination';

const VRAPending = props => {
  const {
    data: { pendingReturnInvoices, refetch },
    setPageAction,
  } = props;

  const [selectedVRAPending, setSelectedVRAPending] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const onSearchSubmitHandler = useCallback(event => {
    const { dealerNumber, vin, vra } = event.target;
    refetch({
      dealerNumber: dealerNumber.value.trim() || null,
      vin: vin.value.trim() || null,
      vra: vra.value.trim() || null,
    });
    setPageAction({});
  }, [refetch, setPageAction]);

  const onDetailsCloseHandler = () => {
    setIsDetailsModalOpen(false);
    setSelectedVRAPending(null);
  };

  const onActionHandler = (action, pendingVRA) => {
    if (!action || !pendingVRA) return;
    switch (action) {
      case 'view':
        setSelectedVRAPending(pendingVRA);
        setIsDetailsModalOpen(true);
        break;
      case 'allow':
        // eslint-disable-next-line no-console -- disable since for future implementation
        console.log('allow', pendingVRA);
        break;
      case 'invalidate':
        // eslint-disable-next-line no-console -- disable since for future implementation
        console.log('invalidate', pendingVRA);
        break;
      default:
        break;
    }
  };

  const allowPendingVRA = () => {
    onActionHandler('allow', selectedVRAPending);
    onDetailsCloseHandler();
  };

  const invalidatePendingVRA = () => {
    onActionHandler('invalidate', selectedVRAPending);
    onDetailsCloseHandler();
  };

  return (
    <div>
      <Header>VRA Pending</Header>
      <VRAPendingSearch
        onSubmit={onSearchSubmitHandler}
        searchFields={{}}
        searchOptions={['dealerNumber', 'vin', 'vra']}
      />
      <VRAPendingList
        VRAsPending={pendingReturnInvoices}
        actionHandler={onActionHandler}
      />
      {selectedVRAPending && isDetailsModalOpen && (
        <VRAPendingDetails
          pendingVRA={selectedVRAPending}
          isDetailsModalOpen={isDetailsModalOpen}
          onCloseHandler={onDetailsCloseHandler}
          allowPendingVRA={allowPendingVRA}
          invalidatePendingVRA={invalidatePendingVRA}
        />
      )}
    </div>
  );
};

const mapStateToProps = () => {

};

const mapDispatchToProps = dispatch => ({
  setPageAction: () => dispatch(setPage({})),
});

VRAPending.propTypes = {
  data: PropTypes.shape({
    pendingReturnInvoices: PropTypes.array,
    refetch: PropTypes.func,
  }),
  setPageAction: PropTypes.func,
};

export default compose(
  withRouter,
  withPagination(pendingReturnInvoicesQuery, 'pendingReturnInvoices'),
  graphql(pendingReturnInvoicesQuery, { name: 'pendingReturnInvoicesData' }),
  connect(mapStateToProps, mapDispatchToProps)
)(VRAPending);
